module.exports = __webpack_public_path__ + "img/sld_scb_12_t1_b1.b963be02.svg";